export const c1Words = [
  {
    word: "acknowledgement",
    image: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExMjJnbGxjMHI5dzV0OXM1dml3YTh6NmoyZnB0OGs4eWthcmw5MTJ3dCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/mH2sAsmOLtQ8cuUlcc/giphy.gif",
    synonyms: ["recognition", "admission", "acceptance"],
    example: "He gave a brief nod in acknowledgement of her help.",
    definition:
      "The act of recognizing or admitting the existence or truth of something.",
  },
  {
    word: "allegation",
    image: "https://i.pinimg.com/736x/0d/9c/37/0d9c37f7c597184d2b7ae9bdd8bdb5b2.jpg",
    synonyms: ["claim", "accusation", "assertion"],
    example: "The politician denied all allegations of corruption.",
    definition:
      "A statement that someone has done something wrong or illegal, without proof.",
  },
  {
    word: "anticipate",
    image: "https://i.pinimg.com/736x/d5/ea/67/d5ea67ee3ccdefa1aa9478da34c8da51.jpg",
    synonyms: ["expect", "foresee", "predict"],
    example: "We anticipate a rise in demand this summer.",
    definition:
      "To expect or look ahead to something with pleasure or concern.",
  },
  {
    word: "articulate",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNjA1aXplZzE1a2w2OHphZ2N3cm9pdXZ1MXV0N2pzMTZldnRsejBqdSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xXg51bnrbdZTupzqFf/giphy.gif",
    synonyms: ["express", "convey", "communicate"],
    example: "She is able to articulate her ideas clearly and confidently.",
    definition: "To express thoughts or ideas clearly and effectively.",
  },
  {
    word: "coherent",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExOGQwMnBlM2Izc3BucjhmbWpqMW82Y2d4ZW1obWJ4MXJ0cDJyd2M2eSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NIQJf69MC2e5WEikgG/giphy.gif",
    synonyms: ["logical", "consistent", "rational"],
    example: "He presented a coherent argument in court.",
    definition: "Logical and well organized; easy to understand.",
  },
  {
    word: "comprehensive",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWhzc2tiM29lMTBodGdndTV5NzNzYzVneHRwZWdvdDhvcHk2dWphaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/d481ZU0B4Il1U1YbRi/giphy.gif",
    synonyms: ["complete", "thorough", "all-inclusive"],
    example: "This book provides a comprehensive overview of modern art.",
    definition: "Including everything that is necessary; complete.",
  },
  {
    word: "contemplate",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExMDR3cTNzcHZtbnE0MHh4cjc3aTVzaWpmZWQ2dzNrbzRnZHFmcmRzNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o6gE9ChU8MOYP4WRO/giphy.gif",
    synonyms: ["consider", "reflect on", "ponder"],
    example: "She contemplated moving to another city.",
    definition: "To think deeply or carefully about something.",
  },
  {
    word: "convey",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExYTlhZHFiZjUxem5yOHFzejZrbWkxd3BpY244MjlicmEwNTQ0N24wMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Xo5ybgibmLbrKxtjGR/giphy.gif",
    synonyms: ["communicate", "express", "transmit"],
    example: "He tried to convey his excitement through words.",
    definition: "To express or communicate something.",
  },
  {
    word: "credible",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExaXM5N2lzaXN5ZDk4eWg3NGU1aWVhbXR4NmNrZHB2dzYxZXZ6N2xwNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/58ZXZdJ0XeZy3HnkBA/giphy.gif",
    synonyms: ["believable", "trustworthy", "reliable"],
    example: "The witness gave a credible account of the events.",
    definition: "Able to be believed or trusted.",
  },
  {
    word: "deduce",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExc3Bmemt4cjNvOHhiYnhzMGFzbXlha3RvOWNyY3QxYWxuNTBrYTFlZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/dgEtXsuqq2PL2/giphy.gif",
    synonyms: ["infer", "conclude", "assume"],
    example: "We can deduce from the evidence that he was present.",
    definition: "To reach a conclusion based on known facts.",
  },
  {
    word: "discrepancy",
    image: "https://plus.unsplash.com/premium_photo-1668081838487-9bb0ca32c73c?q=80&w=1123&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["difference", "inconsistency", "variation"],
    example: "There is a discrepancy between the two reports.",
    definition: "A difference between two things that should be the same.",
  },
  {
    word: "emerge",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExNHJidTIwamY2MG8wamw5ZGF4eGd4MXVxbDk3bGg1djh5YzdmMW82YyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/i7EvbrzyNoIR38uavt/giphy.gif",
    synonyms: ["appear", "arise", "come out"],
    example: "A new leader emerged from the crisis.",
    definition: "To appear or become known.",
  },
  {
    word: "emphasize",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbXBlNmRtY2UzMjh5c2x0eW13bm5yMzk4a294a2tiZnhveTZzYmxuNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/hxmH7Ma6RnssL0RXRi/giphy.gif",
    synonyms: ["highlight", "stress", "underscore"],
    example: "The speaker emphasized the importance of teamwork.",
    definition: "To give special importance to something.",
  },
  {
    word: "inevitable",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExb25oYXNjM3Qyd2FuZHA2M3p2b3BhdmN5YzY2NjloNnQzaG1lYTRuNyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/XZ0nC4yg4hp3trHLt4/giphy.gif",
    synonyms: ["unavoidable", "certain", "bound to happen"],
    example: "Change is inevitable in every organization.",
    definition: "Certain to happen and impossible to avoid.",
  },
  {
    word: "interpret",
    image: "https://i.pinimg.com/736x/50/04/01/5004016b88b2260430fcd6affa3a3661.jpg",
    synonyms: ["explain", "translate", "understand"],
    example: "It's hard to interpret dreams sometimes.",
    definition: "To explain the meaning of something.",
  },
  {
    word: "justify",
    image: "https://media.istockphoto.com/id/2019979263/photo/legal-rights-concept-statue-of-lady-justice-holding-scales-of-justice.jpg?s=2048x2048&w=is&k=20&c=mJ9aVsNTbc9VscTBof7YqBnDZx5csDt2N-lQvDVLuwc=",
    synonyms: ["defend", "explain", "validate"],
    example: "How can you justify your decision?",
    definition: "To show or prove that something is right or reasonable.",
  },
  {
    word: "notion",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNTI3MHhta25nNm91dm85NHJiMmo0amtud2NqeXdqN3pxdHAxdGU4dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/eRJqh9THP32HuT0YRo/giphy.gif",
    synonyms: ["idea", "belief", "concept"],
    example: "She has a romantic notion of life in the countryside.",
    definition: "An idea or belief about something.",
  },
  {
    word: "perspective",
    image: "https://i.pinimg.com/736x/79/69/00/7969003a49be87b104b5afcfbc5b4afb.jpg",
    synonyms: ["viewpoint", "outlook", "angle"],
    example: "From my perspective, the plan seems risky.",
    definition: "A particular way of thinking about or looking at something.",
  },
  {
    word: "preliminary",
    image: "https://images.unsplash.com/photo-1692420602815-00dbfa174ac1?q=80&w=711&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["initial", "introductory", "preparatory"],
    example: "These are just the preliminary results of the study.",
    definition: "Happening before something more important.",
  },
  {
    word: "reluctant",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExYWhqZWJ1NHM3eG5yN2h2ZXlxNGdwdHo2ZGl4cDAzYmQ1OGFmZHF2YSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ah8z0cgXWsk3lD5IBq/giphy.gif",
    synonyms: ["unwilling", "hesitant", "disinclined"],
    example: "He was reluctant to accept the offer.",
    definition: "Unwilling and hesitant to do something.",
  },
  {
    word: "subsequent",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWdkNTQ4MTliY3VxanBzNXp3aW9xa2IzMjBzc29pdG4xZWZvZW9zYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/US2whUE84Dzh9kL187/giphy.gif",
    synonyms: ["following", "later", "next"],
    example: "Subsequent events proved him wrong.",
    definition: "Happening or coming after something else.",
  },
  {
    word: "subtle",
    image: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExaDRpc2hybndkdW50NXpvMG94YTE1dTU5ZjZ5N2lsZTg2enZjcTVhcSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xT39DddfV3IZYHIUta/giphy.gif",
    synonyms: ["delicate", "faint", "indirect"],
    example: "There was a subtle change in her tone.",
    definition: "Not obvious; delicate and precise.",
  },
  {
    word: "sustain",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExY2twcWhhcGQ3dDVpZzB4ZW9peGZlaDVtemJzM3Q5czM4d2hlZjRtdCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ZI4owdgI8ob1LtkFjt/giphy.gif",
    synonyms: ["maintain", "support", "preserve"],
    example: "He couldn’t sustain the pace of work.",
    definition: "To keep something going over time.",
  },
  {
    word: "trigger",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExeHdpNWM3dmg1Nm0xbTZlYmZ5OWM3OHFyOWx0c2tvNWhseHo0YXJ4ciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7Tl05ZgfexJSwOoqKz/giphy.gif",
    synonyms: ["cause", "initiate", "spark"],
    example: "The news triggered a strong reaction.",
    definition: "To cause something to start suddenly.",
  },
  {
    word: "undermine",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcWI4bGV3cnFobDdpMmJkcmdwZnN3cGFkOGMzbjU4bWozeW40aXV3eSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3GjMC3jYD9QgLhrmYT/giphy.gif",
    synonyms: ["weaken", "erode", "damage"],
    example: "His comments undermined her confidence.",
    definition: "To make someone or something weaker.",
  },
];
